export default __webpack_public_path__ + "static/media/single_choice.7e1ac042.svg";